// extracted by mini-css-extract-plugin
export default {"searchBar":"TaggedImage_searchBar__eMmmi","taggedImage":"TaggedImage_taggedImage__jRiDF","endMessage":"TaggedImage_endMessage__Gf4CX"};